if (
  document.getElementById("close-btn") &&
  document.getElementById("overlay-custom-modal")
) {
  document.getElementById("close-btn").addEventListener("click", function () {
    document
      .getElementById("overlay-custom-modal")
      .classList.remove("d-block", "is-visible");
    document.getElementById("overlay-custom-modal").classList.add("d-none");
    document
      .getElementById("modal-custom")
      .classList.remove("d-block", "is-visible");
    document.getElementById("modal-custom").classList.add("d-none");
    $("body").css("overflow-y", "scroll");
  });

  document.addEventListener("click", function (el) {
    if ($(".overlay-custom-modal").hasClass("is-visible")) {
      if (el.target.id !== "" && el.target.id === "overlay-custom-modal") {
        document
          .getElementById("overlay-custom-modal")
          .classList.remove("d-block", "is-visible");
        document.getElementById("overlay-custom-modal").classList.add("d-none");
        document
          .getElementById("modal-custom")
          .classList.remove("d-block", "is-visible");
        document.getElementById("modal-custom").classList.add("d-none");
        $("body").css("overflow-y", "scroll");
      }
    }
  });
}
